module.exports = __webpack_public_path__ + "5e4d19a4.png";